import { render, staticRenderFns } from "./TenantEditWeb.vue?vue&type=template&id=5253fcce&scoped=true&"
import script from "./TenantEditWeb.vue?vue&type=script&lang=js&"
export * from "./TenantEditWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5253fcce",
  null
  
)

export default component.exports